<div class="lock-details">
  <div class="header mt-3 mb-5">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        *ngIf="stepper > 1"
        (click)="navigateBack()"
      />

      <h1 class="modal-title m-auto">{{ 'ACTIVITY_TYPE' | translate }}</h1>

      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>
  </div>
  <div class="activity-type-container">
    <form [formGroup]="formGroup" novalidate>
      <div>
        <ng-container *ngFor="let activityType of activityTypes; let i = index">
          <div class="form-group rounded-top form-container">
            <div
              class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
            >
              <div class="d-flex list-box full">
                <input
                  type="radio"
                  class="d-none"
                  [value]="activityType.value"
                  #radioRef
                  formControlName="eventType"
                />

                <span
                  class="title bold col-10"
                  #el
                  [ngClass]="{
                    'overflow-ellipsis': true,
                    'cursor-help': el.scrollWidth > el.clientWidth && showHelpCursor
                  }"
                  matTooltip="{{ el.innerHTML }}"
                >
                  {{ activityType.eventType }}
                </span>
                <span class="selected-value-container checked-spacer col-2">
                  <span class="selected-value time-right"> </span>
                  <span class="btn-not-text">
                    <button
                      class="icon-button-checked"
                      type="button"
                      (click)="
                        radioRef.click(); updateActivityType(activityType)
                      "
                    >
                      <img
                        class="icon"
                        [src]="
                          activityType.active
                            ? '/assets/svg/ico-checkmark-circle-outline.svg'
                            : '/assets/svg/ico-circle.svg'
                        "
                      />
                    </button>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>

  <div class="row mt-5">
    <div class="col-12">
      <button class="btn btn-danger px-3 w-100 btn-submit" (click)="submit()">
        {{ 'CONTINUE' | translate }}
      </button>
    </div>
  </div>
</div>
